import { AbstractControl, FormArray, UntypedFormArray, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Patterns } from './patterns';

export class CustomValidator {
  static noWhiteSpace(control: AbstractControl): ValidationErrors | null {
    let crtValue = control.value;
    if (crtValue) { crtValue = crtValue.trim(); }
    if (!crtValue) { return { required: true }; }
    return null;
  }
  static MatchValidator(sourceKey: string, targetKey: string): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const source = group.get(sourceKey);
      const target = group.get(targetKey);

      if (source && target) {
        const sourceVal = source.value;
        const targetVal = target.value;

        const errors = target.errors || {};
        // If values don't match → add notMatch
        if (sourceVal && targetVal && (sourceVal !== targetVal)) {
          target.setErrors({ ...errors, notMatch: true });
        }
      }

      return null; // no group-level error
    };
  }
  static arabicTextValidator(control: AbstractControl): ValidationErrors | null {
    let text = control.value || '';

    // Clean HTML tags
    text = text.replace(/<[^>]*>/g, '');

    // Decode HTML entities
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    text = textArea.value;

    text = text.trim();

    if (!text) return null;

    // Pattern allowing Arabic letters, Arabic-Indic & Latin digits, spaces, and extended punctuation (including • and ·)
    const arabicPattern = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\s0-9\u0660-\u0669•·،؛؟ـ.,!@#$%^&*()_+\-=\[\]{}::"';<>\/\\|~`%]+$/;

    return arabicPattern.test(text) ? null : { nonArabic: true };
  }
  static englishTextValidator(control: AbstractControl): ValidationErrors | null {
    let text = control.value || '';

    // Remove HTML tags
    text = text.replace(/<\/?[^>]+(>|$)/g, '');

    // Decode HTML entities (like &amp;, &lt;, etc.)
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    text = textArea.value;

    // Trim whitespace
    text = text.trim();

    // Skip validation if empty
    if (!text) return null;

    // Pattern allowing English letters, numbers, spaces, accented chars, and extended punctuation (including •, ·, —, ’, “”)
    const englishPattern = /^[a-zA-ZÀ-ÿœŒ\s0-9.,!?@#$%^&*()_+\-=\[\]{}::"';<>\/\\|~`%•·—’'""«»€£]+$/;

    return englishPattern.test(text) ? null : { nonEnglish: true };
  }

  static atLeastOneSelectedValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const options = control.get('options') as FormArray;
      if (!options) return null;
      const anyChecked = options.controls.some((c) => c.value === true);
      return anyChecked ? null : { atLeastOneRequired: true };
    };
  }
  static priceRange(lowKey: string, highKey: string): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const lowControl = group.get(lowKey);
      const highControl = group.get(highKey);

      if (!lowControl || !highControl) {
        return null;
      }

      const low = lowControl.value;
      const high = highControl.value;

      if (low !== null && high !== null && low !== '' && high !== '' && +low >= +high) {
        highControl.setErrors({ ...highControl.errors, priceRange: true });
        return { priceRange: true };
      }

      if (highControl.hasError('priceRange')) {
        const { priceRange, ...remainingErrors } = highControl.errors || {};
        highControl.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
      }

      return null;
    };
  }

  static noWhiteSpaceMinChar(minlength: number, control: AbstractControl): ValidationErrors | null {
    let crtValue = control.value;
    if (crtValue) { crtValue = crtValue.trim(); }
    if (!crtValue) { return { required: true }; }
    if ((crtValue ? crtValue.split("").length : 0) < minlength) { return { minlength: true } }
    return null;
  }

  static multipleCheckboxRequireOne(fa: UntypedFormArray) {
    let valid = false;

    for (let x = 0; x < fa.length; ++x) {
      if (fa.at(x).value.check) {
        valid = true;
        break;
      }
    }
    if (!valid) { return { required: true }; }
    return null;
  }
}
